import React from 'react';
import {
  Pagination,
  TablePagination,
  TablePaginationProps,
} from '@mui/material';

function PaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));

  if (totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      count={totalPages}
      page={page + 1}
      onChange={(_, newPage) => onPageChange(null, newPage - 1)}
      size="small"
      shape="rounded"
      siblingCount={3}
      boundaryCount={1}
      sx={{
        flexShrink: 0,
        '.MuiPagination-ul': {
          flexWrap: 'nowrap',
        },
        '.MuiPaginationItem-root': {
          minWidth: 28,
          height: 28,
          px: 0.5,
        },
      }}
    />
  );
}

type TablePaginationWithPagesProps = TablePaginationProps;

const TablePaginationWithPages = (props: TablePaginationWithPagesProps) => {
  const { sx, ...rest } = props;

  return (
    <TablePagination
      {...rest}
      ActionsComponent={PaginationActions}
      sx={{
        ...sx,
        '.MuiTablePagination-toolbar': {
          minHeight: '52px',
          paddingRight: '16px',
          flexWrap: 'nowrap',
          gap: 1,
        },
        '.MuiTablePagination-selectLabel': {
          color: 'rgba(0, 0, 0, 0.54)',
          lineHeight: '1.4375em',
          marginRight: '8px',
          flexShrink: 0,
        },
        '.MuiTablePagination-select': {
          marginRight: '16px',
          flexShrink: 0,
        },
        '.MuiTablePagination-displayedRows': {
          flex: 'none',
          marginRight: 'auto',
          flexShrink: 0,
          whiteSpace: 'nowrap',
        },
        '.MuiTablePagination-actions': {
          marginLeft: 0,
          flexShrink: 0,
        },
      }}
    />
  );
};

export default TablePaginationWithPages;
